import React from "react";

const SignUp = () => {
  return <>SignUp</>;
};

export default SignUp;
